module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/global_map_bg_with_news.d7af790a.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/global_map_bg_with_news.jpg
// module id = 2978
// module chunks = 11